function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import memoDownshiftProps from "sprout-ui-dom/dist/memoDownshiftProps";
import { TopicSelectable } from "sprout-ui-dom/dist/Selectables";
import { Add } from "sprout-ui-icons";
import { Box } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
const StyledBox = styled(Box)`
  border-top: 1px solid ${themeGet("colors.white.12")};
`;
const MemoTopicSelectable = memoDownshiftProps(TopicSelectable);
const MoveItemsDialogAdd = (props)=>{
    const { getItemProps , inputValue  } = props;
    return /*#__PURE__*/ _jsx(StyledBox, {
        flex: "none",
        pt: "4px",
        pb: "16px",
        children: /*#__PURE__*/ _jsx(MemoTopicSelectable, _objectSpread({
            save: false,
            title: inputValue ? `Add "${inputValue}"` : "Add branch",
            icon: Add
        }, getItemProps({
            item: inputValue || ""
        })))
    });
};
export default MoveItemsDialogAdd;
